module.exports = __webpack_public_path__ + "media/images/avatar/01-25d73c6c21e74abcba4e4f54d6730ddd.jpg";